import React from 'react';
import { ArrowRight, Heart } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta" className="w-full bg-gradient-to-b from-white to-lavender-light/20 py-24 px-6 md:px-8 text-center" style={{
    paddingTop: '50px',
    paddingBottom: '50px'
  }} data-id="element-12">
      <div className="max-w-2xl mx-auto" data-id="element-13">
        {/* Emotional opener */}
        <p className="text-base text-text-light mb-4 italic" data-id="element-14">
          Si estás leyendo esto con el bebé en brazos, a oscuras, con el celular
          en una mano…
        </p>

        <h2 className="text-3xl md:text-5xl font-bold text-text leading-tight mb-6" data-id="element-15">
          Esto es para ti. <br data-id="element-16" />
          <span className="text-lavender-dark" data-id="element-17">Justo ahora.</span>
        </h2>

        {/* Validation block */}
        <div className="bg-cream p-6 md:p-8 rounded-2xl border border-lavender/20 mb-10 text-left space-y-4" style={{
        paddingLeft: '15px',
        paddingRight: '15px'
      }} data-id="element-18">
          <p className="text-lg md:text-xl text-text leading-relaxed" data-id="element-19">
            No estás fallando. Estás haciendo lo más difícil que has hecho en tu
            vida
            <span className="font-bold" data-id="element-20">
              {' '}
              sin manual, sin dormir y muchas veces sin ayuda.
            </span>
          </p>
          <p className="text-lg md:text-xl text-text leading-relaxed" data-id="element-21">
            Este guión no te va a convertir en una supermamá. Pero mañana,
            cuando abras los ojos sin saber qué hacer…
            <span className="font-bold text-lavender-dark" data-id="element-22">
              vas a tener una respuesta.
            </span>
          </p>
          <p className="text-lg md:text-xl text-text leading-relaxed" data-id="element-23">
            Y eso, cuando estás en modo zombie,
            <span className="font-bold" data-id="element-24">lo cambia todo.</span>
          </p>
        </div>

        {/* The reframe — purchasing as self-care */}
        <div id="offer-price" className="mb-10 scroll-mt-10" data-id="element-25">
          <div className="inline-flex items-center gap-2 bg-lavender-light/50 px-4 py-1.5 rounded-full mb-4" data-id="element-26">
            <span className="text-xs font-bold text-lavender-dark uppercase tracking-wide" data-id="element-27">
              🔥 68% de descuento
            </span>
            <span className="text-xs text-text-light" data-id="element-28">
              • Por tiempo limitado
            </span>
          </div>

          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-29">
            <span className="text-2xl md:text-3xl line-through text-text-light/60" data-id="element-30">
              $19.89
            </span>
            <span className="text-4xl md:text-5xl font-bold text-lavender-dark" data-id="element-31">
              $6.39
            </span>
            <span className="text-sm text-text-light self-end mb-2" data-id="element-32">USD</span>
          </div>

          <p className="text-xl md:text-2xl font-serif text-text mb-2" data-id="element-33">
            No es un gasto.
          </p>
          <p className="text-xl md:text-2xl font-serif text-lavender-dark font-bold" data-id="element-34">
            Es lo primero que haces por ti en semanas.
          </p>
        </div>

        {/* CTA button */}
        <a href="https://shop.magneticademente.com/cart/52272543695127:1" className="inline-flex items-center gap-3 bg-lavender-dark hover:bg-text text-white px-8 py-5 rounded-full text-lg md:text-xl font-bold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1" style={{
        paddingTop: '20px',
        paddingBottom: '20px'
      }} data-id="element-35">
          Descarga el Plan de Supervivencia
          <span className="hidden md:inline" data-id="element-36">Postparto (0–30 días)</span>
          <ArrowRight className="w-5 h-5" data-id="element-37" />
        </a>

        {/* Closing emotional lines */}
        <div className="mt-8 space-y-3" data-id="element-38">
          <p className="text-lg md:text-xl text-text font-medium leading-relaxed" data-id="element-39">
            Mañana no empieza en cero. <br data-id="element-40" />
            Mañana empiezas con un plan.
          </p>
          <div className="flex items-center justify-center gap-2 text-text-light mt-4" data-id="element-41">
            <Heart className="w-4 h-4 text-rose-DEFAULT" data-id="element-42" />
            <p className="text-sm italic" data-id="element-43">
              De una mamá que también estuvo ahí, para ti.
            </p>
          </div>
        </div>
      </div>
    </section>;
}